import React, { useEffect } from 'react';
import './YourSixElement.scss';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { getTranslation } from '../../constants/translations';
import { scrollTop } from '../../helpers/scrollTop';

type YourSixElementTrans = {
  [key: string]: {
    title: string;
    text: string;
    label: string;
  }[];
};

export const YourSixElement = () => {
  const location = useLocation();
  const route = location.pathname.slice(1);
  const t: YourSixElementTrans = getTranslation().yourSixElements;
  const yourSixTranslation = getTranslation().yourSix;
  let title = '';

  switch (route) {
    case 'shop':
    case 'marketing':
    case 'finance':
    case 'statistics':
    case 'settings':
    case 'dashboard':
      title = yourSixTranslation[route].title;
      break;
  }

  useEffect(() => {
    scrollTop();
  });

  return (
    <section className="your-six-element">
      <div className="_container">
        <div className="your-six-element__container">
          <div
            className={`your-six-element__logo your-six-element__logo--${route}`}
          ></div>

          <ul className="your-six-element__cards-list your-six-element__cards-list--shop">
            <div className="your-six-element__title">
              {title[0].toUpperCase() + title.slice(1)}
            </div>

            {t[route].map((elem) => (
              <li
                key={elem.label}
                className={`your-six-element__item your-six-element__item--${route} your-six-element__item--${elem.label}`}
              >
                <div className="your-six-element__item-title">{elem.title}</div>
                <p className="your-six-element__item-text">{elem.text}</p>
              </li>
            ))}

            <div className="your-six-element__buttons-container">
              {location.pathname !== ROUTES.SHOP && (
                <Link
                  to={ROUTES.SHOP}
                  className="button your-six-element__button your-six-element__button--shop"
                >
                  {yourSixTranslation.shop.title}
                </Link>
              )}

              {location.pathname !== ROUTES.MARKETING && (
                <Link
                  to={ROUTES.MARKETING}
                  className="button your-six-element__button your-six-element__button--marketing"
                >
                  {yourSixTranslation.marketing.title}
                </Link>
              )}

              {location.pathname !== ROUTES.FINANCE && (
                <Link
                  to={ROUTES.FINANCE}
                  className="button your-six-element__button your-six-element__button--finance"
                >
                  {yourSixTranslation.finance.title}
                </Link>
              )}

              {location.pathname !== ROUTES.STATISTICS && (
                <Link
                  to={ROUTES.STATISTICS}
                  className="button your-six-element__button your-six-element__button--statistics"
                >
                  {yourSixTranslation.statistics.title}
                </Link>
              )}

              {location.pathname !== ROUTES.SETTINGS && (
                <Link
                  to={ROUTES.SETTINGS}
                  className="button your-six-element__button your-six-element__button--settings"
                >
                  {yourSixTranslation.settings.title}
                </Link>
              )}

              {location.pathname !== ROUTES.DASHBOARD && (
                <Link
                  to={ROUTES.DASHBOARD}
                  className="button your-six-element__button your-six-element__button--dashboard"
                >
                  {yourSixTranslation.dashboard.title}
                </Link>
              )}
            </div>
          </ul>
        </div>
      </div>
    </section>
  );
};
